import { environment as env } from 'environments/environment';

export const stsLoginUri = `${env.stsUrl}account/login`;
export const myProfileUri = `${env.stsUrl}user`;
export const changePasswordUri = `${env.stsUrl}manage/changepassword`;
export const listOfClientsUri = `${env.stsUrl}client/clients`;